import { useEffect, useState } from "react";

import LineAltIcon from "../../../../../../Components/Icon-SVG/LineAltIcon";
import DetailsTable from "./DetailsTable";
import SigmaOutputSection from "./SigmaOutputSection";
import { cleanRuleName } from "./threatDetailsUtils";
import DetailButton from "../../DetectionDetailPopup/DetailButton";
import useDetectionDetailPopup from "../../DetectionDetailPopup/useDetectionDetailPopup";

const prepareDetailsTableData = (threatDetail, severity) => {
  if (!threatDetail) return {};

  if (threatDetail?.type === "sigma") {
    return {
      Severity: severity,
      "Rule Name": threatDetail.rule_name,
      "Rule Description": threatDetail.rule_description,
    };
  } else if (threatDetail?.type === "Yara" || threatDetail.type === "CAV") {
    return {
      Severity: severity,
      Name: cleanRuleName(threatDetail.threat),
      Description: threatDetail.description || "-",
      File: threatDetail.file,
      "Signature Status": threatDetail.signature_status,
    };
  } else {
    return {};
  }
};

const ThreatDetailsContent = ({ severity, selectedThreatDetail }) => {
  const { findFileDetail, openDetail, popup } = useDetectionDetailPopup();

  const [outputExpanded, setOutputExpanded] = useState(false);

  const isSigma = selectedThreatDetail?.type === "sigma";
  const isGroupedRule =
    (selectedThreatDetail?.type === "Yara" || selectedThreatDetail?.type === "CAV") &&
    selectedThreatDetail?.matches?.length > 0;

  // Collapse the output again when another rule is selected
  useEffect(() => {
    setOutputExpanded(false);
  }, [selectedThreatDetail]);

  return (
    <div className="thunter-threat-details__content">
      <div className="thunter-threat-details__content__header">
        <div className="thunter-threat-details__content__file-name">
          <div className="thunter-threat-details__content__icon-container">
            <LineAltIcon color="white" width={18} height={18} />
          </div>
          <p>Rule name is "{selectedThreatDetail?.value}"</p>
        </div>
        <div
          className={`thunter-threat-details__content__severity thunter-threat-details__content__severity--${severity?.toLowerCase()}`}>
          {severity}
        </div>
      </div>

      {isSigma ? (
        <div className="thunter-threat-details__content__mid">
          <p className="thunter-threat-details__content__key-value">
            <span>Selector:</span> {selectedThreatDetail?.selector || "-"}
          </p>
        </div>
      ) : null}

      {isGroupedRule ? (
        <div className="thunter-threat-details__content__mid">
          <p className="thunter-threat-details__content__key-value">
            <span>Description:</span> {selectedThreatDetail?.description || "-"}
          </p>
        </div>
      ) : null}

      {isSigma && outputExpanded ? null : (
        <div className="thunter-threat-details__content__details">
          {isGroupedRule ? (
            selectedThreatDetail.matches.map((match, index) => {
              const fileDetail = findFileDetail(match.file);

              return (
                <div className="thunter-threat-details__content__bottom" key={index}>
                  <DetailsTable
                    data={{
                      Severity: severity,
                      File: (
                        <>
                          {match.file}
                          {fileDetail ? (
                            <DetailButton
                              title="Show file details"
                              onClick={() => openDetail(fileDetail)}
                            />
                          ) : null}
                        </>
                      ),
                      "Signature Status": match.signature_status || "-",
                    }}
                  />
                </div>
              );
            })
          ) : (
            <div className="thunter-threat-details__content__bottom">
              <DetailsTable data={prepareDetailsTableData(selectedThreatDetail, severity)} />
            </div>
          )}
        </div>
      )}

      {isSigma ? (
        <SigmaOutputSection
          ruleKey={selectedThreatDetail?.rule_key}
          expanded={outputExpanded}
          setExpanded={setOutputExpanded}
        />
      ) : null}

      {popup}
    </div>
  );
};

export default ThreatDetailsContent;
